export function loadScript(src: string): Promise<HTMLScriptElement> {
  return new Promise<HTMLScriptElement>((resolve, reject) => {
    // Check for script first
    let script: HTMLScriptElement | null = document.querySelector(
      `script[src='${src}']`
    );
    if (script != null) {
      return reject("Script already loaded in page");
    }

    script = document.createElement("script");
    script.async = true;
    script.onerror = e => reject(e);
    script.onload = () => resolve();
    script.src = src;
    if (document.body) {
      document.body.appendChild(script);
    } else {
      document.head.appendChild(script);
    }
  });
}
